import { FormikHelpers } from "formik";
import { INotificationFormValues } from "../schema/notifications.schema";

export interface IFormHookValues {
  loading: boolean;

  initialValues: INotificationFormValues | undefined;
  previewOpen: boolean;

  isCreate: boolean;
  isEdit: boolean;
  isView: boolean;
  mode: INotificationFormMode;

  imageFileName: string;
}

export interface IFormHookActions {
  handleCancelOrClose: () => void;
  handleSubmit: (
    values: INotificationFormValues,
    helpers: FormikHelpers<INotificationFormValues>
  ) => Promise<void>;
  handlePreview: (values: INotificationFormValues) => void;
  handleRemoveFile: () => void;
  handleUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  closePreview: () => void;
}

export interface IActionRules {
  showCancel: boolean;
  showPreview: boolean;
  showSubmit: boolean;
  submitLabel?: string;
}

export type INotificationFormMode = "create" | "edit" | "view";
export enum NotificationFormModeEnum {
  CREATE = "create",
  EDIT = "edit",
  VIEW = "view",
}
export const { CREATE, EDIT, VIEW } = NotificationFormModeEnum;

export enum FormFieldEnum {
  TITLE = "title",
  MESSAGE = "message",

  CENTERS = "centers",
  SEGMENTS = "segments",
  PROFILES = "profiles",

  START_AT = "startAt",
  END_AT = "endAt",

  IMAGE_URL = "imageUrl",
}
